import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Embed from "../views/Embed.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/us",
    component: Embed,
    name: "US",
    props: {
      country: "us"
    }
  },
  {
    path: "/uk",
    component: Embed,
    name: "UK",
    props: {
      country: "uk"
    }
  },
  {
    path: "/fr",
    component: Embed,
    name: "FR",
    props: {
      country: "fr"
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
